import OnboardingCreateTeam from './OnboardingCreateTeam'

export default OnboardingCreateTeam
